
    <ingo-global-error
      [error]="error$ | async"
      (onReload)="reload()"
      (onClose)="close()">
    </ingo-global-error>